import { createStore } from 'vuex'
import { appointment, newAppointment } from "./modules/store.appointment";
import { users } from "./modules/store.users";
import { editedManager, manager } from "./modules/store.manager";
import { newCustomer } from "./modules/store.customer_reg";
import { editedCustomer } from "./modules/store.customer";
import { editedVet } from "./modules/store.vet";
import { editedAvailabilityConfig } from "./modules/store.vet";
import { products } from "./modules/store.products";
import { appointmentsAccessCodes } from "./modules/store.appointments_access_codes";
import { specialties, editedSpecialty } from "./modules/store.specialties";


export default createStore({
    modules: {
        appointment,
        newAppointment,
        users,
        manager,
        newCustomer,
        editedCustomer,
        editedVet,
        editedManager,
        editedAvailabilityConfig,
        products,
        appointmentsAccessCodes,
        specialties,
        editedSpecialty}
})
